import { render, staticRenderFns } from "./EventConfirmationDashlet.vue?vue&type=template&id=3df7182e"
import script from "./EventConfirmationDashlet.vue?vue&type=script&lang=js"
export * from "./EventConfirmationDashlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports